import { eventBus } from '@Foundation/eventbus';

const injectedUrls = [];

export function loaded(binding) {
  const tag = document.createElement('script');
  const head = document.getElementsByTagName('head')[0];

  tag.src = binding.url;
  tag.async = true;

  if (binding.attributes) {
    Object.keys(binding.attributes).forEach((key) => {
      tag.setAttribute(key, binding.attributes[key]);
    });
  }

  head.appendChild(tag);

  /* istanbul ignore next */
  tag.onload = () => fireLoadedEvent(binding.value, binding.url);
}

export function fireLoadedEvent(name, url) {
  eventBus.$emit('script.loaded', { name, url });
}
export const loadscript = {
  name: 'loadscript',
  bind: (el, binding) => {
    if (binding.value && binding.url && !injectedUrls.includes(binding.url)) {
      injectedUrls.push(binding.url);
      loaded(binding);
    }
  },
};
